var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bag-modal", on: { click: _vm.closeModal } },
    [
      _c(
        "div",
        {
          staticClass: "bag-card",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bag-tabs" },
            [
              _c(
                "button",
                {
                  class: [
                    "tab-btn",
                    { active: _vm.currentActiveTab === "全部" },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "全部"
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        全部 (" +
                      _vm._s(
                        Object.keys(_vm.categorizedItems["全部"] || {}).length
                      ) +
                      ")\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.categoryOrder, function (category) {
                return _c(
                  "button",
                  {
                    key: category,
                    class: [
                      "tab-btn",
                      { active: _vm.currentActiveTab === category },
                    ],
                    attrs: {
                      disabled:
                        !_vm.categorizedItems[category] ||
                        Object.keys(_vm.categorizedItems[category]).length ===
                          0,
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = category
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(category) +
                        " (" +
                        _vm._s(
                          _vm.categorizedItems[category]
                            ? Object.keys(_vm.categorizedItems[category]).length
                            : 0
                        ) +
                        ")\n      "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "bag-content" }, [
            Object.keys(_vm.bag).length === 0
              ? _c("div", { staticClass: "empty-bag" }, [
                  _c("p", [_vm._v("背包为空")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "empty-tip" }, [
                    _vm._v("通过探索和修炼来获取物品"),
                  ]),
                ])
              : Object.keys(_vm.currentCategoryItems).length === 0
              ? _c("div", { staticClass: "empty-category" }, [
                  _c("p", [_vm._v(_vm._s(_vm.currentActiveTab) + "分类为空")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "empty-tip" }, [
                    _vm._v("该分类下暂无物品"),
                  ]),
                ])
              : _c(
                  "div",
                  { staticClass: "bag-items" },
                  _vm._l(_vm.currentCategoryItems, function (count, itemName) {
                    return _c(
                      "div",
                      { key: itemName, staticClass: "bag-item" },
                      [
                        _c("div", { staticClass: "item-info" }, [
                          _c("span", { staticClass: "item-name" }, [
                            _vm._v(_vm._s(itemName)),
                          ]),
                          _vm._v(" "),
                          count > 0
                            ? _c("span", { staticClass: "item-count" }, [
                                _vm._v("×" + _vm._s(count)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "view-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.showItemInfo(itemName)
                                },
                              },
                            },
                            [_vm._v("\n              查看\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "use-btn",
                              attrs: { disabled: !_vm.canUseItem(itemName) },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.useItem(itemName)
                                },
                              },
                            },
                            [_vm._v("\n              使用\n            ")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bag-footer" }, [
            _c(
              "button",
              { staticClass: "close-btn", on: { click: _vm.closeModal } },
              [_vm._v("关闭")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bag-header" }, [
      _c("h3", [_vm._v("背包物品")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }